import React, { useState, useContext } from "react";
import { globalInfo } from "../../App";
import AdminHeader from "./AdminHeader";
import AdminNavigation from "./AdminNavigation";
import AdminFooter from "./AdminFooter";
import { ToastContainer, toast } from "react-toastify";
import {
  submitFormData,
  getParticipantsList,
} from "../../Utils/adminFunctions";
import dataTableGrid from "../DataTableGrid";
import { get_Date } from "../../Utils/commonFunctions";

let ImportParticipants = () => {
  const { ip_address } = useContext(globalInfo);
  const [participantCsv, setParticipantCsv] = useState("");
  const [showPopup, setShowPopup] = useState(false);
  const [importDataMessage, setImportDataMessage] = useState("");
  const [errorParticipantCsv, setErrorParticipantCsv] = useState("");
  const [listDoctors, setListDoctors] = useState([]);
  const [desabledBtn, setDesabledBtn] = useState(false);

  let handleCsvChange = (participantcsv) => {
    if (participantcsv) {
      setParticipantCsv(participantcsv);
    } else {
      setParticipantCsv("");
    }
  };
  const manage_participants = async () => {
    const bodyFormData = new FormData();
    const response = await getParticipantsList(bodyFormData);
    if (response.status === "success") {
      setListDoctors(response.data);
      dataTableGrid({
        data_table_id: "#userlist",
        paginate: false,
        scroller: false,
        copy_option: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,
        ],
        csv_option: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,
        ],
        print_option: [
          0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19,
          20, 21, 22, 23, 24,
        ],
        sort_option: [25],
      });
    } else if (response.status === "failure") {
      toast.error(response, { autoClose: 1500 });
    }
  };

  const importParticipants = async () => {
    setDesabledBtn(true);
    let errorRequiredFiled = 0;
    if (participantCsv === "") {
      setErrorParticipantCsv("Can not be empty");
      errorRequiredFiled = errorRequiredFiled + 1;
    }
    if (participantCsv !== "" && !participantCsv.name.match(/\.(csv)$/)) {
      toast.warning("Select valid csv file", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }
    if (errorRequiredFiled > 0) {
      toast.warning("Required fields are missing ", { autoClose: 1500 });
      setDesabledBtn(false);
      return false;
    }

    const bodyFormData = new FormData();
    bodyFormData.append("participants_csv", participantCsv);
    bodyFormData.append("entered_by_ip", ip_address);
    const response = await submitFormData("importParticipants", bodyFormData);
    if (response.status === "success") {
      manage_participants();
      setParticipantCsv("");
      setShowPopup(true);
      setDesabledBtn(false);
      document.getElementById("participants_csv").value = "";
      setImportDataMessage(response.message);
    } else {
      toast.warning(response.message, { autoClose: 1500 });
      setShowPopup(false);
      setDesabledBtn(false);
    }
  };
  const popupClose = () => {
    setShowPopup(false);
  };
  return (
    <div>
      <div className="wrapper">
        <div>
          <ToastContainer></ToastContainer>
          <AdminHeader />
          <AdminNavigation />
          <div className="content-wrapper">
            <div className="content-header"></div>
            <section className="content">
              <div className="container-fluid">
                <div className="row">
                  <div className="col-md-12">
                    <div className="card">
                      <div className="card-header">
                        <div className="row">
                          <div className="col-md-8">
                            <h3 className="card-title card-header-link custom-link-primary">
                              <b>Import Participants </b>{" "}
                            </h3>
                          </div>
                          <div className="col-md-4">
                            <h3 className="card-title pull-right "></h3>
                          </div>
                        </div>
                      </div>
                      <div className="card-body">
                        <div className="col-md-12 text-center p-5">
                          <input
                            type="file"
                            accept="csv/*"
                            className={errorParticipantCsv ? " is-invalid" : ""}
                            id="participants_csv"
                            onChange={(e) => {
                              setErrorParticipantCsv("");
                              handleCsvChange(e.target.files[0]);
                            }}
                          />
                          <div className="text-center mt-5 p-2">
                            <button
                              type="button"
                              className="btn btn-sm custom-btn-primary mt-2 mb-2"
                              onClick={importParticipants}
                              disabled={desabledBtn}
                            >
                              Import Participant
                            </button>
                            <div
                              className={
                                showPopup ? "modal fade show" : "modal fade"
                              }
                              id="import_true"
                              arial-modal="true"
                              style={{ display: showPopup ? "block" : "" }}
                            >
                              <div className="modal-dialog">
                                <div className="modal-content">
                                  <div className="modal-header">
                                    <h6 className="modal-title">
                                      Import Participants{" "}
                                    </h6>
                                    <button
                                      type="button"
                                      className="close"
                                      data-dismiss="modal"
                                      aria-label="Close"
                                      id="close_modal"
                                      onClick={popupClose}
                                    >
                                      <span aria-hidden="true">×</span>
                                    </button>
                                  </div>
                                  <div className="modal-body">
                                    <p className="text-success">
                                      {importDataMessage}
                                    </p>
                                  </div>
                                  <div className="modal-footer">
                                    <button
                                      type="button"
                                      data-dismiss="modal"
                                      className="btn btn-sm custom-btn-primary"
                                      onClick={popupClose}
                                    >
                                      OK
                                    </button>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="card">
                      <div className="card-body table_scroll">
                        <table
                          id="userlist1"
                          className="table table-bordered table-striped"
                        >
                          <thead>
                            <tr>
                              <th>S. No.</th>
                              <th>First Name</th>
                              <th>Middle Name</th>
                              <th>Last Name</th>
                              <th>Email</th>
                              <th>Business Email</th>
                              <th>Website</th>
                              <th>Contact no.</th>
                              <th>Region</th>
                              <th>Country</th>
                              <th>State</th>
                              <th>City</th>
                              <th>Address</th>
                              <th>Zip/Postal code</th>
                              <th>Category</th>
                              <th>Specilization</th>
                              <th>Qualification</th>
                              <th>Source</th>
                              <th>Source reference</th>
                              <th>Hospital Name</th>
                              <th>Created by</th>
                              <th>Created date</th>
                              <th>Verified by</th>
                              <th>Verified date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {listDoctors ? (
                              listDoctors.map((item, i) => (
                                <tr key={++i}>
                                  <td>{++i}</td>
                                  <td>{item.first_name}</td>
                                  <td>{item.middle_name}</td>
                                  <td>{item.last_name}</td>
                                  <td>{item.email}</td>
                                  <td>{item.business_email}</td>
                                  <td>{item.website}</td>
                                  <td>{item.contact}</td>
                                  <td>{item.region_name}</td>
                                  <td>{item.country_name}</td>
                                  <td>{item.state_name}</td>
                                  <td>{item.city}</td>
                                  <td>{item.address}</td>
                                  <td>{item.zip_code}</td>
                                  <td>{item.category_name}</td>
                                  <td>{item.specialization_name}</td>
                                  <td>{item.qualification}</td>
                                  <td>{item.source}</td>
                                  <td>{item.source_refrrence}</td>
                                  <td>{item.hospital_name}</td>
                                  <td>{item.entered_by}</td>
                                  <td>{get_Date(item.created_date)}</td>
                                  <td>{item.varify_by}</td>
                                  <td>{get_Date(item.modified_date)}</td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan={24} className="text-center">
                                  Result not found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
          <AdminFooter />
        </div>
      </div>
    </div>
  );
};

export default ImportParticipants;
